import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getPDPCustomizerURLParams } from 'components/consumer/PDP/helpers/pdpQueryParamUtils';
const slugify = value => value == null ? null : String(value).trim().toLowerCase().replace(/[\s_]+/g, '-');

// True when the URL's fabric/leather/mixedFabric or orientation param doesn't
// match the given default. An upholstery param with no known default also
// counts as a mismatch.
//
// Reads the raw URL, not selectedOptionsExtended, which is empty until options
// resolve and so misses the mismatch on a fresh load (CON-8543).
const usePDPDeepLinkVariantMismatch = t0 => {
  const {
    defaultUpholsteryValue: t1,
    defaultOrientation: t2
  } = t0 === undefined ? {} : t0;
  const defaultUpholsteryValue = t1 === undefined ? null : t1;
  const defaultOrientation = t2 === undefined ? null : t2;
  const location = useLocation();
  let t3;
  bb0: {
    const params = getPDPCustomizerURLParams(location);
    if (!params) {
      t3 = false;
      break bb0;
    }
    const urlUpholstery = params.fabric || params.leather || params.mixedFabric;
    if (urlUpholstery && slugify(urlUpholstery) !== slugify(defaultUpholsteryValue)) {
      t3 = true;
      break bb0;
    }
    if (params.orientation && slugify(params.orientation) !== slugify(defaultOrientation)) {
      t3 = true;
      break bb0;
    }
    t3 = false;
  }
  return t3;
};
export default usePDPDeepLinkVariantMismatch;